import { lazy, Suspense } from 'react';
import { Modal, View } from 'react-native';
import type { Course } from '@/types/chat';

const BookCallModal = lazy(() => import('./BookCallModal').then(mod => ({ default: mod.BookCallModal })));

interface Props {
  visible: boolean;
  course: Course | null;
  onClose: () => void;
}

export function LazyBookCallModal(props: Props) {
  if (!props.visible) return null;

  return (
    <Suspense fallback={
      <Modal visible={props.visible} transparent animationType="fade">
        <View style={{ flex: 1, backgroundColor: 'rgba(0, 0, 0, 0.5)' }} />
      </Modal>
    }>
      <BookCallModal {...props} />
    </Suspense>
  );
}
